export const CONSENT_KEY = "cookie_consent";

export function getConsent() {
  try {
    return JSON.parse(localStorage.getItem(CONSENT_KEY));
  } catch {
    return null;
  }
}

export function setConsent(consent) {
  localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
}
